import styled from "styled-components";
import NavBar from "./NavBar";
import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import {
  Map as GoogleMap,
  Marker,
  useApiIsLoaded,
} from "@vis.gl/react-google-maps";
import { mapStyle } from "./mapStyle";

const Container = styled.div`
  width: 100vw;
  height: 100dvh;
  background-color: #7a7978;
`;

const Header = styled.div`
  height: 55px;
  background-color: #000;
  color: #d4d4d4;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 10px;
  font-size: 1.5rem;
  box-shadow: 0 2px 40px -10px #000;
  font-weight: 700;
  text-transform: uppercase;
`;

const MenuButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 25px;
  border-radius: 28px;
  box-shadow: 0 2px 40px -10px ${(props) => props.theme.color};
  color: #fff;
  font-size: 16px;
  white-space: nowrap;
  position: absolute;
  bottom: 30px;
  left: 50%;
  background-color: #000;
  font-weight: bold;
  transform: translate3d(-50%, 0, 0);
  cursor: pointer;
  z-index: 105;
  transition: 0.15s cubic-bezier(0.33, 1, 0.53, 1);
  visibility: ${(props) => (props.show ? "hidden" : "visible")};
`;

const Logo = styled.img`
  left: 20px;
  width: 170px;
`;

const Map = () => {
  const { city } = useParams();
  const mapIsLoaded = useApiIsLoaded();
  const [shopId, setShopId] = useState(city || false);
  const [isNavbarVisible, setIsNavbarVisible] = useState(false);
  const cities = {
    gyor: "Győr",
    csorna: "Csorna",
    moson: "Mosonmagyaróvár",
    fertod: "Fertőd HAMAROSAN!",
  };

  return (
    <Container>
      <Header>
        <Link to={"/"}>
          <Logo src={"/logo.png"} />
        </Link>
      </Header>

      <GoogleMap
        style={{ width: "100%", height: "calc(100svh - 65px)" }}
        defaultCenter={{ lat: 47.5571334, lng: 17.2339594 }}
        defaultZoom={9}
        gestureHandling={"none"}
        disableDefaultUI={true}
        onClick={() => setShopId(false)}
        styles={mapStyle}
        controlled={false}
      >
        {mapIsLoaded && (
          <>
            <Marker
              key="gyor"
              position={{ lat: 47.69411613216108, lng: 17.63496037004523 }}
              onClick={() => setShopId("gyor")}
              icon={{
                url: "/gyorMarker.png",
                scaledSize: new window.google.maps.Size(70, 70),
              }}
            />

            <Marker
              key="moson"
              position={{ lat: 47.87681558892161, lng: 17.272411547812556 }}
              onClick={() => setShopId("moson")}
              icon={{
                url: "/mosonMarker.png",
                scaledSize: new window.google.maps.Size(160, 70),
              }}
            />
            <Marker
              key="csorna"
              position={{ lat: 47.61641322944748, lng: 17.247692309933054 }}
              onClick={() => setShopId("csorna")}
              icon={{
                url: "/csornaMarker.png",
                scaledSize: new window.google.maps.Size(70, 70),
              }}
            />
            <Marker
              key="fertod"
              position={{ lat: 47.64972863207846, lng: 16.879650323727162 }}
              onClick={() => setShopId("fertod")}
              icon={{
                url: "/fertodMarker.png",
                scaledSize: new window.google.maps.Size(70, 70),
              }}
            />
          </>
        )}
      </GoogleMap>

      <MenuButton onClick={() => setIsNavbarVisible(true)}>
        Foglalja azonnal
      </MenuButton>
      <NavBar
        isVisible={isNavbarVisible}
        setIsNavbarVisible={setIsNavbarVisible}
        setShopId={setShopId}
        shopId={shopId}
        city={cities[shopId]}
      />
    </Container>
  );
};

export default Map;
